import { faEye, faLock } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import {
    STROLLER_STROLLEROPEDIA,
    WIKI_REVIEWS,
} from 'mk/autogenerated/translations/ArticleHeader.729212dcce6d6ac51648c07ca2193859'
import { getArticleTitleAsHTML } from 'mk2/apps/blogs/containers/Article/Article.helpers';
import { getPostDate } from 'mk2/apps/blogs/helpers';
import { UserChip } from 'mk2/apps/forum/components/UserChip';
import { strollersArticlesOfSectionUrl, strollersUrl } from 'mk2/apps/strollers/urls';
import { WIKI_REVIEWS_ARTICLE_SLUG } from 'mk2/apps/wiki/helpers';
import { getWikiArticleUrl } from 'mk2/apps/wiki/urls';
import { BadgeType, BADGE_CONFIGS } from 'mk2/components/Badge';
import { BreadcrumbSiteStructure } from 'mk2/components/BreadcrumbSiteStructure';
import { Emojify } from 'mk2/components/Emojify';
import { Link } from 'mk2/components/Link';
import { dateLocal } from 'mk2/helpers/timeformat';
import { url } from 'mk2/helpers/urls';
import { BlogPostEntity, PostVisibility } from 'mk2/schemas';
import React from 'react';
import styles from './ArticleHeader.mscss';

interface OwnProps {
    article: Pick<
        BlogPostEntity,
        'createdAt' | 'user' | 'visibility' | 'viewsCountTotal' | 'titleAST' | 'titleASTAdditionalData' |
        'hashtagItems' | 'lastChanged'
    >;
    hashtagBadgeTypes: BadgeType[];
    sectionBadgeType: string;
}

type Props = OwnProps;

export default class ArticleHeader extends React.Component<Props> {

    private static getBreadcrumbItems(type) {
        const breadcrumbLinks = [];
        breadcrumbLinks.push(
            <Link className={styles.BreadcrumbItem} key={'1'} to={strollersUrl}>
                {STROLLER_STROLLEROPEDIA}
            </Link>,
        );
        breadcrumbLinks.push(BADGE_CONFIGS[type].sectionSlug ? (
            <Link className={styles.BreadcrumbItem} key={'2'}
                to={url(strollersArticlesOfSectionUrl, { sectionSlug: BADGE_CONFIGS[type].sectionSlug })}
            >
                {BADGE_CONFIGS[type].label}
            </Link>
        ) : <>{BADGE_CONFIGS[type].label}</>);
        return breadcrumbLinks;
    }

    public render() {
        const {
            article,
            hashtagBadgeTypes,
            sectionBadgeType,
        } = this.props;

        const showViewsCount =
            article.viewsCountTotal > 0 ||
            // views sa meraju iba pre clanky vytvorene po 2015-11-05 14:00 utc
            (article.createdAt && Date.parse(article.createdAt) >= Date.UTC(2015, 11, 5, 14, 0, 0));

        return (
            <div className={styles.ArticleHeader}>
                {sectionBadgeType && (
                    <BreadcrumbSiteStructure
                        items={ArticleHeader.getBreadcrumbItems(sectionBadgeType)}
                        className={styles.ArticleHeader__breadcrumb}
                    />
                )}
                <div className={styles.ArticleHeader__meta}>
                    <UserChip user={article.user} size={24} boldUsername />

                    <div className={styles.ArticleHeader__metaDate}>{dateLocal(getPostDate(article))}</div>

                    {showViewsCount && (
                        <div className={styles.ArticleHeader__metaViews}>
                            {article.viewsCountTotal}&nbsp;
                            <FontAwesomeIcon icon={faEye} />
                        </div>
                    )}

                    {article.visibility !== PostVisibility.Public && (
                        <div className={styles.ArticleHeader__metaVisibility}>
                            <FontAwesomeIcon icon={faLock} />
                        </div>
                    )}
                </div>

                {hashtagBadgeTypes?.length ? (
                    <div className={styles.ArticleHeader__hashtags}>
                        {hashtagBadgeTypes.map((type, index) => {
                            const badge = <>
                                {BADGE_CONFIGS[type].icon
                                    ? <FontAwesomeIcon
                                        icon={BADGE_CONFIGS[type].icon}
                                        className={styles.ArticleHeader__hashtags__item__icon}
                                    />
                                    : null}
                                {BADGE_CONFIGS[type].label}
                            </>;
                            return BADGE_CONFIGS[type].sectionSlug ? (
                                <Link
                                    key={index}
                                    className={styles.ArticleHeader__hashtags__item}
                                    to={url(strollersArticlesOfSectionUrl, { sectionSlug: BADGE_CONFIGS[type].sectionSlug })}
                                >
                                    {badge}
                                </Link>
                            ) : badge;
                        })}
                    </div>
                ) : null}

                <h1 className={styles.ArticleHeader__title}>
                    <Emojify size={26}>{getArticleTitleAsHTML(article)}</Emojify>
                </h1>
            </div>
        );
    }
}
